import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, Button, Popover, PopoverHeader, PopoverBody, UncontrolledPopover, } from "reactstrap";
import styles from "./styles";
import { Checkbox } from "react-inputs-validation";
import Formulario from "../Generales/Formulario";
import Steps from "../Generales/Steps";
import Page from "../Page";


const TablaCoberturasIndividual = (
    {
        planesComparador,
        planSeleccionadoMain,
        setPlanSeleccionadoMain,
        coberturasAdicionalesComparador,
        setCoberturasAdicionalesComparador,
        coberturasAdicionalesComparadorModificados,
        setCoberturasAdicionalesComparadorModificados,
        coberturasSeleccionadas,
        valorAsegurado,
        limiteAmparo,
        codigoProductoEspecial,
        vehiculoActual
    }
) => {



    const [bloquearAmparo, setBloquearAmparo] = useState(false)
    const [codEspecial, setCodEspecial] = useState(
        codigoProductoEspecial ? codigoProductoEspecial : ''
        //'pits'
    )
    const [popoverOpen, setPopoverOpen] = React.useState(false);
    const [popover, setPopover] = useState(
        {
            titulo: '',
            descripcion: ''
        }
    )
    const [planes, setPlanes] = useState(planesComparador)

    const [planSeleccionado, setPlanSeleccionado] = useState(
        planSeleccionadoMain ? planSeleccionadoMain : planes.filter(plan => plan.visible === true)[0]
    )

    const [amparosABloquear, setAmparosABloquear] = useState(null)


    useEffect(() => {

        if (vehiculoActual.amparos) {
            setAmparosABloquear(vehiculoActual.amparos)
        }
        if (!planSeleccionadoMain) {
            setPlanSeleccionadoMain(planes.filter(plan => plan.visible === true)[0])
        } else {
            setPlanSeleccionado(planSeleccionadoMain)
        }
    }, [])

    useEffect(() => {
        const aplica = planSeleccionado.coberturasAdicionales.find(cob => cob.aplica == true && cob.codigo == 'amparoPatrimonial3')
        console.log('coberturasAdicionales22222', planSeleccionado)

        console.log()

        if (valorAsegurado >= (limiteAmparo ? limiteAmparo : 30000) && aplica) {
            const encontrado = coberturasAdicionalesComparador.find(cob => cob.codigo == aplica.codigo)

            setBloquearAmparo(false)

            console.log('coberturasAdicionales', encontrado)

            if (!encontrado) {

                const clonedData = [...coberturasAdicionalesComparador];



                const existe = clonedData.findIndex(data => data.codigo === aplica.codigo)

                clonedData.push({ codigo: aplica.codigo })



                setCoberturasAdicionalesComparador(clonedData, true)

            }
        } else {
            setBloquearAmparo(false)
        }
    }, [valorAsegurado, planSeleccionado, coberturasAdicionalesComparador])

    useEffect(() => {
        console.log('clonedData', planes);

        if (!planSeleccionadoMain) {
            setPlanSeleccionadoMain(planes.filter(plan => plan.visible === true)[0]);
        } else {
            setPlanSeleccionado(planSeleccionadoMain);
        }

        // Siempre filtrar "objetosOlvidados"
        let planAux = { ...planSeleccionado };

        if (planAux.coberturasAdicionales) {
            planAux.coberturasAdicionales = planAux.coberturasAdicionales.filter(cobertura => cobertura.codigo !== 'objetosOlvidados');
        }

        setPlanSeleccionado(planAux);
    }, [planSeleccionadoMain]);

    useEffect(() => {

        console.log('coberturasSeleccionadas', coberturasSeleccionadas, planSeleccionado)


        var nuevoArray = []

        if (coberturasSeleccionadas) {

            planSeleccionado.coberturasAdicionales.forEach(element => {

                var coberturaEncontrada = coberturasSeleccionadas[element.codigo]

                if (coberturaEncontrada) {
                    nuevoArray.push({
                        codigo: element.codigo
                    })
                }
            });


            console.log('element', nuevoArray)

            setCoberturasAdicionalesComparador(nuevoArray, false)

        }



    }, [])

    return (

        <main >


            <div >
                <div>


                    {planSeleccionado.coberturasAdicionales &&
                        <div style={styles.divPreguntas2}>
                            <div style={styles.divCoberturas2}>
                                <div style={styles.divTitulo3}>
                                    <div style={styles.divEncabezado2}>
                                        <span style={styles.tituloEncabezado2}>
                                            Coberturas adicionales

                                        </span>
                                    </div>
                                    <div style={{ ...styles.divCategoriaPrecio }}>
                                        <span style={styles.tituloCoberturasPrecio}>
                                        </span>
                                    </div>
                                    {/* Aquí aplicas el filtro */}
                                    {planSeleccionado.coberturasAdicionales
                                        .filter(cobertura => cobertura.codigo !== 'objetosOlvidados')
                                        .map(cobertura => (
                                            <div style={{ ...styles.divCategoriaPrecio2 }}>
                                                <span style={styles.tituloCategoria2} onClick={() => setPopover({ titulo: cobertura.titulo, descripcion: cobertura.descripcion })}>
                                                    <div id={"Popover1"} style={styles.elipse}>
                                                        <i style={styles.elipseText}
                                                            className='fa fa-question'
                                                            aria-hidden='true'
                                                        />
                                                    </div>
                                                    {cobertura.titulo}
                                                </span>
                                            </div>
                                        ))
                                    }
                                </div>

                                <div style={styles.divTitulo2}>
                                    <div style={styles.divEncabezado3}>
                                    </div>
                                    <div style={{ ...styles.divCategoriaPrecio3 }}>
                                    </div>
                                    {planSeleccionado.coberturasAdicionales
                                        .filter(cobertura => cobertura.codigo !== 'objetosOlvidados') // Aquí también aplicas el filtro
                                        .map(cobertura => {

                                            let editarDisponible = (amparosABloquear && !amparosABloquear[cobertura.codigo])

                                            return (
                                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                                    <div style={{ ...styles.divCategoriaPrecio5 }}>
                                                        <div style={coberturasAdicionalesComparador.find(data => data.codigo === cobertura.codigo) ? { ...styles.divBotonQuitar, cursor: editarDisponible ? 'pointer' : 'not-allowed' } : { ...styles.divBotonAgregar, cursor: editarDisponible ? 'pointer' : 'not-allowed' }}
                                                            onClick={() => {


                                                                if (editarDisponible) {

                                                                    const clonedData = [...coberturasAdicionalesComparador];
                                                                    const clonedData2 = [...coberturasAdicionalesComparador];



                                                                    const existe = clonedData.findIndex(data => data.codigo === cobertura.codigo);
                                                                    console.log('clonedData', existe)
                                                                    if (existe === -1) {
                                                                        clonedData.push({ codigo: cobertura.codigo });
                                                                    } else {
                                                                        clonedData.splice(existe, 1);
                                                                    }

                                                                   


                                                                    setCoberturasAdicionalesComparador(clonedData, true);



                                                                    const clonedDataModificados = {...coberturasAdicionalesComparadorModificados};



                                                              

                                                                
                                                                    clonedData2.forEach(element => {
                                                                        clonedDataModificados[cobertura.codigo]= true
                                                                    
                                                                    });

                                                                    console.log('existeModificado111', clonedDataModificados)
                                                                  

                                                                

                                                                 
 

                                                                    setCoberturasAdicionalesComparadorModificados(clonedDataModificados);

                                                                }


                                                            }}
                                                        >
                                                            <span style={coberturasAdicionalesComparador.find(data => data.codigo === cobertura.codigo) ? styles.textoBotonQuitar : styles.textoBotonAgregar}>
                                                                {
                                                                    coberturasAdicionalesComparador.find(data => data.codigo === cobertura.codigo) ? 'AGREGADO' : 'AGREGAR'
                                                                }
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {coberturasAdicionalesComparador.find(data => data.codigo === cobertura.codigo) &&
                                                        (editarDisponible) ?
                                                        <div>
                                                            <div style={{ ...styles.divCategoriaPrecio6 }}>
                                                                <div style={styles.divBotonQuita2}
                                                                    onClick={() => {
                                                                        if (editarDisponible) {

                                                                            const clonedData = [...coberturasAdicionalesComparador];
                                                                            const clonedData2 = [...coberturasAdicionalesComparador];
                                                                            const existe = clonedData.findIndex(data => data.codigo === cobertura.codigo);
                                                                            console.log('clonedData', existe)
                                                                            if (existe === -1) {
                                                                                clonedData.push({ codigo: cobertura.codigo });
                                                                            } else {
                                                                                clonedData.splice(existe, 1);
                                                                            }
                                                                            setCoberturasAdicionalesComparador(clonedData, true);
        
        
        
                                                                            const clonedDataModificados = {...coberturasAdicionalesComparadorModificados};
        
        
        
                                                                      
        
                                                                        
                                                                            clonedData2.forEach(element => {
                                                                                clonedDataModificados[cobertura.codigo]= true
                                                                            
                                                                            });
        
                                                                            console.log('existeModificado111', clonedDataModificados)                                                            
                                                                         
         
        
                                                                            setCoberturasAdicionalesComparadorModificados(clonedDataModificados);                                                                      }
                                                                    }}
                                                                >
                                                                    <span style={styles.textoBotonQuitar2}>
                                                                        <i className="fa fa-trash" aria-hidden="true"></i>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div> : null
                                                    }
                                                </div>

                                            )
                                        })
                                    }
                                </div>
                            </div>

                            <UncontrolledPopover
                                placement="bottom" isOpen={popoverOpen}
                                target={"Popover1"}
                                trigger="legacy"
                                toggle={() => { setPopoverOpen(!popoverOpen) }}>
                                <PopoverHeader style={styles.popHeader}>{popover.titulo}</PopoverHeader>
                                <PopoverBody>{popover.descripcion}</PopoverBody>
                            </UncontrolledPopover>
                        </div>
                    }



                </div>
            </div>
        </main>
    );
};
export default TablaCoberturasIndividual;
